import { DISPOSITION_UPDATE_AUTODISPO_STATUS_SAGA } from "@/Redux/Disposition/Constants";

export const updateAutoDispoStatus = (
    stationId: string,
    callback: (isDeactivated: boolean, err: Error) => void,
) => {
    return {
        type: DISPOSITION_UPDATE_AUTODISPO_STATUS_SAGA,
        payload: {
            stationId,
            callback,
        },
    };
};
